module.exports = __webpack_public_path__ + "static/media/Reef Pay.9119b72e.png";